import { defineStore } from "pinia";
import { addRoutes } from '@/router';
import menus from '@/menu/index.js';
import getMenuCookie from '@/menu/getMenuCookie.js'
import Cookies from 'js-cookie';

export const useMenuStore = defineStore('menu', {
    state: () => ({
        menu: menus['initial'],
        menuAux: null,
        type_menu:'admin',
        module_access_codes:[],
        module_access_codes_aux:[],
    }),
    actions: {
        setMenu(menu) {
            // console.log('menu__ ',menu);

            this.menu = menu;
        },
        setTypeMenu(type){
            // console.log('type',type);
            this.type_menu= type;
        },
        setMenuAux(menuAux) {
            this.menuAux = menuAux;
        },
        getTypeMenu(){
            return this.type_menu;
        },
        getMenu() {
            return this.menu;
        },
        getMenuAux() {
            return this.menuAux;
        },
        validateAccess(_module_code){
            return this.module_access_codes.includes(_module_code);
        },
        deleteMenu() {
            localStorage.removeItem('menu');
            localStorage.removeItem('menuAux');
        },
        setDynamicRoutes(){
            const menu = JSON.stringify(this.menu);
            const routes = getMenuCookie(JSON.parse(menu));
            const auth = !!Cookies.get('isAuthenticated');

            if(menu && auth){
                this.module_access_codes=[];
                this.module_access_codes_aux=[];
                routes.forEach(route => {
                    this.module_access_codes.push(route.quick_identification_code);

                    this.module_access_codes_aux.push({
                        quick_identification_code: route.quick_identification_code,
                        label: route.label,
                        path: route.path,
                    });
                });
            }
            // Mantener siempre las rutas iniciales (incluye '/') y sumar las dinámicas si hay auth + menú
            const sendRoutes = (menu && auth) ? [...menus['initial'], ...routes] : menus['initial'];
            addRoutes(sendRoutes);
        },
    },
    persist: {
        storage: localStorage
    }
});